import React from "react";
import { Helmet } from "react-helmet";
import { StaticImage } from "gatsby-plugin-image";
import { MicroCombo } from "../components/Trustpilot/TrustpilotWidgets";
import LocationMark from "../components/icons/Locations/LocationMark";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link } from "gatsby";

import "../../scss/main.scss";

export default function OurTeam() {
  return (
    <>
      <Helmet>
        <meta charSet="UTF-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />

        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Edyn Care | Our Team</title>
        <link href="css/main.css" rel="stylesheet" />
        <meta property="og:title" content="Edyn Care | Our Team" />
        <meta property="og:description" content="High quality care in the comfort of your own home." />
        <meta property="og:image" content="https://www.edyn.care/assets/marketing-site/images/open-graph-img.png" />
        <meta property="og:url" content="https://www.edyn.care/our-team" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="edyn.care" />
        <meta property="twitter:url" content="https://www.edyn.care/our-team" />
        <meta name="twitter:title" content="Edyn Care | Our Team" />
        <meta name="twitter:description" content="High quality care in the comfort of your own home." />
        <meta name="twitter:image" content="https://www.edyn.care/assets/marketing-site/images/open-graph-img.png" />
      </Helmet>
      <div className="container">
        <Header />
        <main className="our-team-page partner-london-page">
          <section>
            <div className="locations-landing">
              <div className="locations-landing-left">
                <div className="landing-content-container">
                  <div className="locations-heading">
                    <h1>Our team</h1>
                    <p className="primary">
                      We&apos;re on a mission to give the elderly the power to live independently, at home, on their own terms - happily and safely. A true alternative to care homes.
                    </p>
                    <Link to="/cta" className="button-link">
                      <button className="btn-orange">Book a consultation</button>
                    </Link>
                  </div>
                  <div className="landing-left-bottom">
                    <MicroCombo classNames={"trust-pilot-minimal partner-trust-pilot-mini"} />
                  </div>
                </div>
              </div>
              <div className="locations-landing-right partner-landing-right">
                <div className="partner-hero-image-wrap">
                  <StaticImage
                    src="../../static/assets/marketing-site/images/team/care-awards.jpg"
                    alt="The edyn.care team together"
                    className="location-img our-team-hero-image"
                    objectFit="cover"
                  />
                </div>
                <div className="location-landing-name">
                  <LocationMark className="icon-default" />
                  <p>Members of our team picking up an award at Great British Care Awards in 2025</p>
                </div>
              </div>
            </div>
          </section>
          <hr className="mobile-hide" />
          <section className="our-team-our-story__section">
            <div className="our-team-our-story__image-wrap">
              <StaticImage
                className="our-team-our-story__image"
                src="../../static/assets/marketing-site/images/team/jonny_oliver.jpg"
                alt="Jonny and Oliver, founders of edyn.care"
                objectFit="cover"
              />
            </div>
            <div className="our-team-our-story__copy">
              <h3 className="our-team-our-story__copy-heading">
                We&apos;re Jonny and Oliver, the founders of edyn.care. We&apos;re childhood friends who used to work in politics
                and in finance who founded edyn after our own experiences arranging care for loved ones.
              </h3>
              <br />
              <p className="our-team-out-story__copy-text">
               We were shocked by how difficult it was to arrange care in England. The process was confusing, with no good tools available to make it simpler. Costs were incredibly high, and common options such as care homes often felt impersonal and inhumane. For something as deeply personal as care, the whole experience felt surprisingly heartless.
              </p>
              <br />
              <p className="our-team-out-story__copy-text">
                So we thought we&apos;d try something new. A personal, professional and proactive approach powered by
                professional carers, the human touch and technology. A service which would be fitting for our own loved
                ones. Today, we support hundreds of families, providing the most dependable, personalised live-in care to
                their loved ones. We are a human company first and a technology company second, driven to provide 10
                million hours of care by 2027.
              </p>
            </div>
          </section>
          <hr />
          <section className="our-team-logos__section">
            <div className="our-team-logos__block">
              <h3 className="our-team-logos__block-title">awards</h3>
              <div className="our-team-logos__block-logos">
                <div className="our-team-logos__logo our-team-logos__health-investor-awards-logo">
                  <StaticImage
                    src="../../static/assets/marketing-site/images/our-team-logos/health-investor-awards.png"
                    objectFit="contain"
                  />
                </div>
                <div className="our-team-logos__logo our-team-logos__leading-healthcare-awards-logo">
                  <StaticImage
                    src="../../static/assets/marketing-site/images/our-team-logos/leading-healthcare-awards.png"
                    objectFit="contain"
                  />
                </div>
              </div>
            </div>
            <div className="our-team-logos__block">
              <h3 className="our-team-logos__block-title">regulated by</h3>
              <div className="our-team-logos__block-logos">
                <div className="our-team-logos__logo our-team-logos__cqc-logo">
                  <StaticImage src="../../static/assets/marketing-site/images/our-team-logos/cqc.png" objectFit="contain" />
                </div>
              </div>
            </div>
            <div className="our-team-logos__block">
              <h3 className="our-team-logos__block-title">partners</h3>
              <div className="our-team-logos__block-logos">
                <div className="our-team-logos__logo our-team-logos__skills-for-care-logo">
                  <StaticImage
                    src="../../static/assets/marketing-site/images/our-team-logos/skills-for-care.png"
                    objectFit="contain"
                  />
                </div>
                <div className="our-team-logos__logo our-team-logos__natwest-logo">
                  <StaticImage src="../../static/assets/marketing-site/images/our-team-logos/natwest.png" objectFit="contain" />
                </div>
              </div>
            </div>
          </section>
          <section className="our-team-trustpilot__section">
            <div className="our-team-trustpilot__banner">
              <MicroCombo classNames="trustpilot-rating-banner" />
            </div>
          </section>
          <section className="our-team-members__section">
            <svg
              className="our-team-members__top-background"
              viewBox="0 0 321 136"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clipRule="evenodd"
                d="M-205.644 -30.3513C223.054 153.925 289.466 179.029 634.981 71.8005C980.496 -35.4278 574.465 -567.272 574.465 -567.272L-146.756 -1010.76L-325.02 -1088.26C-325.02 -1088.26 -634.342 -214.628 -205.644 -30.3513Z"
                fill="#E5F2E6"
              />
            </svg>
            <div className="our-team-members__header">
              <h2 className="our-team-members__title">Meet our team</h2>
              <p className="our-team-members__sub-title">
                We are made up of professional carers, support teams, care managers and technologists building a smart
                way to care. The first care company built from the bottom up specifically for live-in care which is proud
                to be regulated by the Care Quality Commission.
              </p>
            </div>
            <div className="our-team-members__grid">
              <div className="our-team-members__person">
                <div className="our-team-members__person-image-wrap">
                  <StaticImage
                    className="our-team-members__person-image"
                    src="../../static/assets/marketing-site/images/team/jonny.png"
                    alt="Jonny Bottomley"
                    objectFit="cover"
                  />
                </div>
                <p className="our-team-members__person-title">CEO</p>
                <h4 className="our-team-members__person-name">Jonny Bottomley</h4>
              </div>
              <div className="our-team-members__person">
                <div className="our-team-members__person-image-wrap">
                  <StaticImage
                    className="our-team-members__person-image"
                    src="../../static/assets/marketing-site/images/team/oliver.png"
                    alt="Oliver Ross"
                    objectFit="cover"
                  />
                </div>
                <p className="our-team-members__person-title">COO</p>
                <h4 className="our-team-members__person-name">Oliver Ross</h4>
              </div>
              <div className="our-team-members__person">
                <div className="our-team-members__person-image-wrap">
                  <StaticImage
                    className="our-team-members__person-image"
                    src="../../static/assets/marketing-site/images/team/sandra.png"
                    alt="Sandra Doru"
                    objectFit="cover"
                  />
                </div>
                <p className="our-team-members__person-title">Registered Care Manager</p>
                <h4 className="our-team-members__person-name">Sandra Doru</h4>
              </div>
              <div className="our-team-members__person">
                <div className="our-team-members__person-image-wrap">
                  <StaticImage
                    className="our-team-members__person-image"
                    src="../../static/assets/marketing-site/images/team/tamas.png"
                    alt="Tamas Sagi"
                    objectFit="cover"
                  />
                </div>
                <p className="our-team-members__person-title">Integrations Engineer</p>
                <h4 className="our-team-members__person-name">Tamas Sagi</h4>
              </div>
              <div className="our-team-members__person">
                <div className="our-team-members__person-image-wrap">
                  <StaticImage
                    className="our-team-members__person-image"
                    src="../../static/assets/marketing-site/images/team/anna.png"
                    alt="Anna Bondar"
                    objectFit="cover"
                  />
                </div>
                <p className="our-team-members__person-title">Family Care Coordinator</p>
                <h4 className="our-team-members__person-name">Anna Bondar</h4>
              </div>
              <div className="our-team-members__person">
                <div className="our-team-members__person-image-wrap">
                  <StaticImage
                    className="our-team-members__person-image"
                    src="../../static/assets/marketing-site/images/team/orianne.png"
                    alt="Orianne Collins"
                    objectFit="cover"
                  />
                </div>
                <p className="our-team-members__person-title">Quality Assurance Manager</p>
                <h4 className="our-team-members__person-name">Orianne Collins</h4>
              </div>
              <div className="our-team-members__person">
                <div className="our-team-members__person-image-wrap">
                  <StaticImage
                    className="our-team-members__person-image"
                    src="../../static/assets/marketing-site/images/team/daniel.png"
                    alt="Daniel Greeves"
                    objectFit="cover"
                  />
                </div>
                <p className="our-team-members__person-title">Family Care Advisor</p>
                <h4 className="our-team-members__person-name">Daniel Greeves</h4>
              </div>
              <div className="our-team-members__person">
                <div className="our-team-members__person-image-wrap">
                  <StaticImage
                    className="our-team-members__person-image"
                    src="../../static/assets/marketing-site/images/team/lavinia.png"
                    alt="Lavinia Puita"
                    objectFit="cover"
                  />
                </div>
                <p className="our-team-members__person-title">Recruitment Specialist</p>
                <h4 className="our-team-members__person-name">Lavinia Puita</h4>
              </div>
              <div className="our-team-members__person">
                <div className="our-team-members__person-image-wrap">
                  <StaticImage
                    className="our-team-members__person-image"
                    src="../../static/assets/marketing-site/images/team/emma.png"
                    alt="Emma Lennon"
                    objectFit="cover"
                  />
                </div>
                <p className="our-team-members__person-title">Family Care Manager</p>
                <h4 className="our-team-members__person-name">Emma Lennon</h4>
              </div>
              <div className="our-team-members__person">
                <div className="our-team-members__person-image-wrap">
                  <StaticImage
                    className="our-team-members__person-image"
                    src="../../static/assets/marketing-site/images/team/sophia.png"
                    alt="Sophia Dulai"
                    objectFit="cover"
                  />
                </div>
                <p className="our-team-members__person-title">Recruitment Specialist</p>
                <h4 className="our-team-members__person-name">Sophia Dulai</h4>
              </div>
              <div className="our-team-members__person">
                <div className="our-team-members__person-image-wrap">
                  <StaticImage
                    className="our-team-members__person-image"
                    src="../../static/assets/marketing-site/images/team/shaun.png"
                    alt="Shaun Louis"
                    objectFit="cover"
                  />
                </div>
                <p className="our-team-members__person-title">Family Care Advisor</p>
                <h4 className="our-team-members__person-name">Shaun Louis</h4>
              </div>
              <div className="our-team-members__person">
                <div className="our-team-members__person-image-wrap">
                  <StaticImage
                    className="our-team-members__person-image"
                    src="../../static/assets/marketing-site/images/team/muna.png"
                    alt="Muna Khamdun"
                    objectFit="cover"
                  />
                </div>
                <p className="our-team-members__person-title">Family Care Manager</p>
                <h4 className="our-team-members__person-name">Muna Khamdun</h4>
              </div>
            </div>

            <svg
              className="our-team-members__bottom-background"
              viewBox="0 0 321 113"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M-680.72 515.452C-755.82 470.876 -892.341 328.679 -687.329 224.821C-482.317 120.962 -120.955 -0.996909 41.0377 0.226805C203.03 1.45052 573.864 253.864 589.91 263.568C605.955 273.273 154.557 206.383 170.273 225.664C185.988 244.944 208.125 313.9 163.997 326.23C119.869 338.56 -247.108 420.311 -256.471 421.482C-265.834 422.654 -165.722 499.991 -267.898 530.559C-370.074 561.126 -605.62 560.028 -680.72 515.452Z"
                fill="#E5F2E6"
              />
            </svg>
          </section>
        </main>
        <section className="bac-cta">
          <div className="bac-cta__card">
            <StaticImage
              src="../../static/assets/marketing-site/images/we-care.png"
              placeholder="blurred"
              objectFit="contain"
            />
            <div className="bac-cta__description">
              <h1 className="bac-cta__description-title">Join our team</h1>
              <p className="bac-cta__description-text our-team-bac-cta__description-text">
                We&apos;re building an amazing team to transform the care industry.
                <br />
                <br />
                See our open positions
              </p>
              <a href="https://www.linkedin.com/company/edyn-care/jobs/" target="_blank" rel="noopener noreferrer">
                <button className="btn-orange">Open linkedin</button>
              </a>
            </div>
          </div>
        </section>
        <Footer includeCTA={false} includeBecomeACarer={true} />
      </div>
    </>
  );
}
